const riot = require('riot');

riot.tag2('module-note', '<h2>{data.title}</h2>', '', '', function(opts) {
    this.preload = async () => {
      var res = await fetch('https://jsonplaceholder.typicode.com/todos/' + this.opts.noteId);
      var data = await res.json();

      return {
        data
      };
    };
});